import { render, staticRenderFns } from "./AuthorsSelection.vue?vue&type=template&id=d2f07a3a"
import script from "./AuthorsSelection.vue?vue&type=script&lang=js"
export * from "./AuthorsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports